<template>
  <div id="app">
    <div v-if="simpleLayout">
      <router-view/>
    </div>
    <div v-else>
      <dashboard>
        <router-view/>
      </dashboard>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex'

import Dashboard from '@/components/Dashboard'

export default {
  name: 'App',
  components: {
    Dashboard
  },
  data() {
    return {};
  },
  created() {
    document.title = 'Painel - 123 Mail'

  },
  mounted() {
      //window.FontAwesomeConfig = {
      //  autoReplaceSvg: false,
      //  observeMutations: false
      //};
      //let fontScript = document.createElement('script')
      //fontScript.setAttribute('src', 'https://unicotracker.com.br/fontawesome-free-5/js/all.js')
      //document.head.appendChild(fontScript)

      const link = document.createElement('link');
      link.rel = 'stylesheet';
      //link.href = 'https://unicotracker.com.br/fontawesome-free-5/css/all.css';
      link.href= "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
      document.head.appendChild(link);
      
  },
  computed: {
      ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    simpleLayout() {
      return (
        !this.user ||
        !this.user.token ||
        [
          "Account",
          "Onboarding",
          "SelectPlan",
          "CanceledAccount",
          "GoogleAdsSelectAccounts",
          "FacebookAdsSelectAccounts",
          "AcceptInvite",
          "LoginOauthG",
          "LoginOauthFB",
          "RemovedContactList"
        ].includes(this.$route.name)
      );
    },
  },
  methods: {
  },


}
</script>
